import { render, staticRenderFns } from "./VChatRoom.vue?vue&type=template&id=8ee0dff0&"
import script from "./VChatRoom.vue?vue&type=script&lang=js&"
export * from "./VChatRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports